// @ts-check
import React from 'react';

import FullScreenError from 'components/molecules/FullScreenError';
import Actions from 'components/standard/HostingDetailsActions';
import Attributes from 'components/standard/HostingDetailsAttributes';
import PageLayout from 'components/standard/PageLayout';
import { useLeftHandLayout } from 'containers/LeftHandLayout';
import hostingDetailsAlsowith from 'containers/pages/servers/details/hostingDetailsAlsowith';
import { usePollAssetDetails } from 'modules/queries/asset/useDetails';
import NotFound from 'pages/error/NotFound';
import { Redirect, useParams } from 'react-router-dom';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import { getErrorStringHelper } from 'utility/redux/selectorHelperFunctions/apiModules';

/** @typedef {import('@liquidweb-dev/undercurrent').Theme['palette']} Palette */

/**
 * A layout for the BeyondHosting server details pages.
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
const BeyondHostingLayout = ({ children }) => {
	/** @type {{uniqId: string}} */
	const { uniqId } = useParams();
	const { topInnerX } = useLeftHandLayout();

	const {
		data: assetDetailsData,
		isLoading: assetDetailsIsLoading,
		isError: assetDetailsIsError,
		error: assetDetailsError,
	} = usePollAssetDetails({
		uniq_id: uniqId,
		alsowith: hostingDetailsAlsowith,
	});

	if (
		assetDetailsIsError &&
		// @ts-expect-error
		assetDetailsError.statusCode === 404
	) {
		return <NotFound />;
	}

	if (assetDetailsIsError) {
		return (
			<FullScreenError content={getErrorStringHelper(assetDetailsIsError)} />
		);
	}

	const { domain, isBeyondHosting } = assetDetailsData || {};

	// redirect non BeyondHosting servers
	if (isBeyondHosting === false) {
		return <Redirect to={`/servers/${uniqId}`} />;
	}

	return (
		<PageLayout
			title={domain || ''}
			attributesSlot={<Attributes />}
			actionsSlot={<Actions />}
			isLoading={assetDetailsIsLoading}
		>
			<Stack sx={{ paddingX: { xs: `${topInnerX}px`, md: 0 }, flexGrow: 1 }}>
				{children}
			</Stack>
		</PageLayout>
	);
};

export default BeyondHostingLayout;
